import { AlCabinet, AlLocatorService, AlStopwatch } from "@al/core";
import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';

import { AlNavigationService } from '@al/ng-navigation-components';

@Component({
    selector:       'app-root',
    templateUrl:    './app.component.html',
    styleUrls:      ['./app.component.scss'],
    providers:      [],
    encapsulation:  ViewEncapsulation.None
})

export class AppComponent implements OnInit {

    lastURL:string          =   '/';
    storage:AlCabinet       =   AlCabinet.ephemeral("portero.state");
    showMenu:boolean        =   true;

    public view:any = {
        authenticated:  false
    };

    constructor(protected router:Router,
                protected activatedRoute: ActivatedRoute,
                protected location:Location,
                protected navigation:AlNavigationService) {
    }

    ngOnInit() {
        this.onInitialize();
    }

    onInitialize = () => {
        this.router.events.subscribe( event => {
            if ( event instanceof NavigationEnd) {
                if (this.activatedRoute.snapshot.firstChild.data['hideMenus']) {
                    this.showMenu = !this.activatedRoute.snapshot.firstChild.data['hideMenus'];
                } else {
                    if (this.activatedRoute.snapshot.firstChild.routeConfig) {
                        if (this.activatedRoute.snapshot.firstChild.routeConfig.path) {
                            // TODO: Because the lazy loading the metadata of the routes is lost.
                            // Disable menus for mfa module.
                            var isSpecialRoute = (this.activatedRoute.snapshot.firstChild.routeConfig.path === "mfa");
                            this.showMenu = !isSpecialRoute;
                            setTimeout(function() {
                                this.showMenu = !isSpecialRoute;
                            },0);
                        }
                    }
                }
            }
        });

        /**
         *  This is a hack for bad behavior in IE11, where the app can achieve authenticated state but not redirect
         *  for reasons that are still not entirely clear.  This task simply watches for a while, redirects to overview if the path is empty or contains access_token,
         *  or -- after about 10 seconds of remaining unauthenticated -- redirects back to the correct URL for the app.
         *
         *  Strangely enough, this works.
         */
        let failCount = 0;
        let maxFails = 4;
        let failover = AlStopwatch.repeatedly( () => {
            try {
                let actingHost = window.location.origin;
                if ( window.location.pathname && window.location.pathname.length > 1 ) {
                    actingHost += window.location.pathname;
                }
                let path = window.location.href.replace( actingHost, '' );
                if ( path === "" || path === "/" || path === "/#" || path === "/#/" || path === "/#/access_token" || path.indexOf( "/#access_token" ) === 0 ) {
                    failCount++;
                    if ( failCount > maxFails ) {
                        let newPath =  AlLocatorService.resolveURL("cd14:accounts", "/#/" );
                        window.location.href =  AlLocatorService.resolveURL( newPath );
                    }
                } else {
                    failCount = 0;
                }
            } catch( e ) {
                console.log("Error: ", e.toString() );
            }
        }, 2000 );
    }
}
